(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('InstrumentSearch', InstrumentSearch);

    InstrumentSearch.$inject = ['$resource'];

    function InstrumentSearch($resource) {
        var resourceUrl =  'api/_search/instruments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
